
import { AspectRatio } from "@/components/ui/aspect-ratio";

const Videos = () => {
  const testimonials = [
    {
      id: "4",
      title: "Basketball Training Review 4",
      url: "https://www.youtube.com/embed/87BXBccCF90",
      isShort: false,
    },
    {
      id: "2",
      title: "Basketball Training Review 2",
      url: "https://www.youtube.com/embed/gbh6WGIkBF0",
      isShort: false,
    },
    {
      id: "3",
      title: "Basketball Training Review 3",
      url: "https://www.youtube.com/embed/hnh_IECIclQ",
      isShort: false,
    },
    {
      id: "1",
      title: "Basketball Training Review 1",
      url: "https://www.youtube.com/embed/7KpYCBUl0MU",
      isShort: false,
    },
  ];

  const trainingVideos = [
    {
      id: "5",
      title: "Basketball Training Highlights",
      url: "https://www.youtube.com/embed/05-MUv1UrbM?si=oyqo--sUv9hARJt4",
      isShort: false,
    },
    {
      id: "6",
      title: "Basketball Training Highlights",
      url: "https://www.youtube.com/embed/p9vdVZ7jvNA",
      isShort: false,
    },
    {
      id: "7",
      title: "Basketball Training Short",
      url: "https://www.youtube.com/embed/FYyFcGXxUrc",
      isShort: true,
    },
    {
      id: "8",
      title: "Basketball Training Highlights",
      url: "https://www.youtube.com/embed/Ga8YvuX8vw8",
      isShort: false,
    },
    {
      id: "9",
      title: "Basketball Training Highlights",
      url: "https://www.youtube.com/embed/-6hWISV1w7w?si=9NrEA71d_tYklFPQ",
      isShort: false,
    },
    {
      id: "10",
      title: "Basketball Training Highlights",
      url: "https://www.youtube.com/embed/4-it8KK5NgE",
      isShort: false,
    }
  ];

  const VideoCard = ({ video }: { video: typeof testimonials[0] }) => (
    <div className="bg-white rounded-lg shadow-md overflow-hidden">
      <div className="w-full">
        <AspectRatio ratio={16/9}>
          <iframe
            src={video.url}
            title={video.title}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            className="w-full h-full"
            loading="lazy"
          />
        </AspectRatio>
      </div>
      <div className="p-2 sm:p-4">
        <h3 className="text-sm sm:text-base md:text-lg font-semibold text-gray-800">{video.title}</h3>
      </div>
    </div>
  );

  return (
    <section className="py-8 sm:py-12 md:py-16 bg-accent">
      <div className="container mx-auto px-3 sm:px-4">
        <h2 id="testimonials" className="text-xl sm:text-2xl md:text-3xl font-bold text-center text-primary mb-6 sm:mb-8 md:mb-12">
          Testimonials
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-4 md:gap-8 mb-8 sm:mb-10 md:mb-16">
          {testimonials.map((video) => (
            <VideoCard key={video.id} video={video} />
          ))}
        </div>

        <h2 id="training-videos" className="text-xl sm:text-2xl md:text-3xl font-bold text-center text-primary mb-6 sm:mb-8 md:mb-12">
          Training Videos
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-4 md:gap-8">
          {trainingVideos.map((video) => (
            <VideoCard key={video.id} video={video} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Videos;
